export type ThemePreference = 'light' | 'dark' | 'system'

/**
 * Applies the given theme preference to the document.
 *
 * Lives in lib/ (not composables/useTheme) so session-free bundles — the www marketing site
 * and its SSR prerender — can apply a theme without pulling the app router + auth graph in
 * through useTheme's useSession import.
 */
export function applyTheme(theme: ThemePreference): void {
    if (typeof window === 'undefined') return

    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
    const shouldBeDark = theme === 'dark' || (theme !== 'light' && prefersDark)
    document.documentElement.classList.toggle('dark', shouldBeDark)
}
